import {AbstractControl, ValidationErrors} from '@angular/forms';
import {SupportedLanguageCode} from '@emma-labs/shared/typescript';

export function getDateFormat(language: SupportedLanguageCode): string {
  return language === 'fr' ? 'd MMMM y à H:mm' : "MMMM d y 'at' h:mm\u00A0a";
}

export const INSERT_TEXT_FR = '[INSÉRER TEXTE]';
export const KEEP_OR_DELETE_FR = '[CONSERVER OU SUPPRIMER]';
export const KEEP_OR_DELETE_EN = '[KEEP OR DELETE]';
export const INSERT_TEXT_EN = '[INSERT TEXT]';
export const TEMPLATE_PROMPTS = [INSERT_TEXT_FR, INSERT_TEXT_EN, KEEP_OR_DELETE_FR, KEEP_OR_DELETE_EN];

export function hasNoInputPrompts(input: AbstractControl): ValidationErrors | null {
  return TEMPLATE_PROMPTS.some((prompt) => input.value?.includes(prompt)) ? {hasNoInputPrompts: true} : null;
}
